import React from 'react'
import { TextField, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';

export default function TopOfAddStepTables(props) {
  return (
    <div style={{ width: "100%", padding: "0px 16px 16px 16px", display: "flex", justifyContent: props.button ? "space-between" : "flex-start", alignItems: "center" }}>
      <TextField

        variant="outlined"
        label={props.textFieldLabel}
        onChange={(e) => props.textFieldChange(e.target.value)}
      />
      {props.button ? (
        <button
          type="button"
          className={props.buttonClass || "button-primary"}
          onClick={() => props.buttonClick()}
          data-testid="createStudy"
          title="Creates new study."
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            height: 36,
          }}
        >
          <AddIcon style={{ fontSize: 18 }} />
          {props.buttonText}
        </button>
      ) : null}
    </div>
  )
}
